
import React from 'react'
import icon from './svgs/clock.svg'
import { BaseIcon } from './_base'

export const ClockIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
